<template>
  <div
    class="presetLoadingOverlay"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="presetLoadingCard">
      <div class="loadingVisual" aria-hidden="true">
        <span class="orbit orbitOuter"></span>
        <span class="orbit orbitInner"></span>
        <div class="iconContainer">
          <b-icon-journal-medical />
        </div>
        <span class="statusDot dotOne"></span>
        <span class="statusDot dotTwo"></span>
        <span class="statusDot dotThree"></span>
      </div>

      <strong>{{ title }}</strong>
      <p>{{ text }}</p>

      <div class="progressTrack" aria-hidden="true">
        <span></span>
      </div>

      <div class="loadingSteps" aria-hidden="true">
        <span>Produto</span>
        <i></i>
        <span>Cultura</span>
        <i></i>
        <span>Estoque</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrescriptionPresetLoading",
  props: {
    title: {
      type: String,
      default: "Preparando item predefinido",
    },
    text: {
      type: String,
      default:
        "Validando produto, cultura, estoque e informações técnicas...",
    },
  },
};
</script>

<style scoped>
.presetLoadingOverlay {
  align-items: center;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  background: rgba(243, 248, 246, 0.9);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 60px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2200;
}

.presetLoadingCard {
  align-items: center;
  background: #fff;
  border: 1px solid rgba(0, 98, 86, 0.18);
  border-radius: 14px;
  box-shadow: 0 22px 60px rgba(18, 57, 50, 0.18);
  color: #2f4642;
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 100px);
  overflow: hidden;
  padding: 32px 38px 26px;
  position: relative;
  text-align: center;
  width: 390px;
}

.presetLoadingCard::before {
  background: linear-gradient(90deg, #006256, #12b8a4, #7a9c87);
  content: "";
  height: 4px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.loadingVisual {
  height: 108px;
  margin-bottom: 14px;
  position: relative;
  width: 108px;
}

.orbit {
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 50%;
  inset: 0;
  position: absolute;
}

.orbitOuter {
  animation: rotateClockwise 2.8s linear infinite;
  border-left-color: #12b8a4;
  border-top-color: #006256;
}

.orbitInner {
  animation: rotateCounterClockwise 2s linear infinite;
  border-bottom-color: #7a9c87;
  border-right-color: #006256;
  inset: 10px;
}

.iconContainer {
  align-items: center;
  background: linear-gradient(145deg, #007568, #00584e);
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(0, 98, 86, 0.28);
  color: #fff;
  display: flex;
  font-size: 31px;
  height: 58px;
  justify-content: center;
  left: 25px;
  position: absolute;
  top: 25px;
  transform: rotate(-3deg);
  width: 58px;
}

.statusDot {
  animation: dotPulse 1.5s ease-in-out infinite;
  background: #12b8a4;
  border: 3px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 98, 86, 0.25);
  height: 13px;
  position: absolute;
  width: 13px;
}

.dotOne {
  right: 1px;
  top: 24px;
}

.dotTwo {
  animation-delay: 0.2s;
  bottom: 8px;
  right: 19px;
}

.dotThree {
  animation-delay: 0.4s;
  bottom: 19px;
  left: 4px;
}

.presetLoadingCard strong {
  color: #173d37;
  font-family: Poppins-Medium, sans-serif !important;
  font-size: 17px;
  font-weight: 600;
}

.presetLoadingCard p {
  color: #6d7f7b;
  font-size: 11px;
  line-height: 1.6;
  margin: 7px 0 20px;
  max-width: 300px;
}

.progressTrack {
  background: #e7efed;
  border-radius: 999px;
  height: 5px;
  overflow: hidden;
  width: 100%;
}

.progressTrack span {
  animation: progressMove 1.6s ease-in-out infinite;
  background: linear-gradient(90deg, #006256, #12b8a4);
  border-radius: inherit;
  display: block;
  height: 100%;
  width: 42%;
}

.loadingSteps {
  align-items: center;
  color: #82918e;
  display: flex;
  font-size: 8px;
  justify-content: center;
  letter-spacing: 0.35px;
  margin-top: 12px;
  text-transform: uppercase;
  width: 100%;
}

.loadingSteps i {
  background: #c9d9d5;
  height: 1px;
  margin: 0 9px;
  width: 22px;
}

@keyframes rotateClockwise {
  to {
    transform: rotate(360deg);
  }
}

@keyframes rotateCounterClockwise {
  to {
    transform: rotate(-360deg);
  }
}

@keyframes dotPulse {
  0%,
  100% {
    transform: scale(0.75);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes progressMove {
  0% {
    transform: translateX(-105%);
  }
  100% {
    transform: translateX(245%);
  }
}

@media (max-width: 700px) {
  .presetLoadingOverlay {
    left: 0;
  }

  .presetLoadingCard {
    max-width: calc(100vw - 32px);
    padding: 28px 24px 24px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .orbit,
  .statusDot,
  .progressTrack span {
    animation: none;
  }

  .progressTrack span {
    opacity: 0.65;
    transform: none;
    width: 100%;
  }
}
</style>
